module.exports = __webpack_public_path__ + "static/img/7.169718b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/video-group/7.jpg
// module id = enfc
// module chunks = 1